import React from 'react';
import { Button, makeStyles, Theme } from '@material-ui/core';
import useFormValidatorCtx from '../../../../../form/ctx-provider/useFormValidatorCtx';
import ErrorMessage from '../../../../cmp/message/ErrorMessage';
import LoadingSymbol from '../../../../cmp/loading/LoadingSymbol';
import useBtnAntragEinreichen from './useBtnAntragEinreichen';
import useCssMediaQuery from '../../../../useCssMediaQuery';
import FormValidatorCtxBo from '../../../../../form/ctx-provider/FormValidatorCtxBo';
import { exportVorschaden } from '../form-vorschaden/input/Vorschaden';
import useWizardFormCtx from '../../ctx-provider/useWizardFormCtx';
import StvJaNeinUnbekannt from '../../../../../consumer/form/dto/StvJaNeinUnbekannt';
import GoogleTagManager from '../../../../../gtm/GoogleTagManager';

const useStyles = makeStyles((theme: Theme) => ({

    rootDesktop: {
        width: 350,
        height: 70,
        borderRadius: 0,
        color: 'white',
        fontSize: 20,
        background: 'linear-gradient(225.89deg,#fc5e22 -1.1%,#fc992c 99.53%) no-repeat',
        '&:disabled': {
            background: theme.palette.grey[500],
            color: 'white'
        },
    },

    rootMobile: {
        width: '100%',
        height: 70,
        borderRadius: 0,
        color: 'white',
        fontSize: 20,
        background: 'linear-gradient(225.89deg,#fc5e22 -1.1%,#fc992c 99.53%) no-repeat',
        '&:disabled': {
            background: theme.palette.grey[500],
            color: 'white'
        },
    }

}));


const TEXT_VERBINDLICH = '2. Jetzt verbindlich abschliessen';
const TEXT_ANTRAG = 'jetzt Antrag einreichen';
const TEXT_LOADING = 'Bitte warten';


const BtnAntragEinreichen: React.FC = () => {
    const classes = useStyles();
    const { fireFormValidatorCtxBo } = useFormValidatorCtx();
    const { loading, error, antragEinreichen } = useBtnAntragEinreichen();
    const { desktopVersion } = useCssMediaQuery();
    const { wizardFormBo } = useWizardFormCtx();

    const existVorschaden = exportVorschaden(wizardFormBo.antrag) === StvJaNeinUnbekannt.JA;
    const TEXT_DEFAULT = existVorschaden ? TEXT_ANTRAG : TEXT_VERBINDLICH;

    const onSubmit = () => {
        // Antrag einreichen wird registriert.        
        FormValidatorCtxBo.doOnSubmitButton = antragEinreichen;
        fireFormValidatorCtxBo();

        // GoogleTagManager
        GoogleTagManager.fireEventBtnAntragEinreichen();
    }

    return (
        <>
            <div>{error && <ErrorMessage />}</div>
            <div>
                <Button onClick={onSubmit}
                    name="btnAntragEinreichen"
                    type='submit' size='large'
                    color='secondary'
                    variant='contained'
                    disabled={(loading === true) || (wizardFormBo.antrag.vviBestaetigung === false)}
                    className={desktopVersion ? classes.rootDesktop : classes.rootMobile}
                    startIcon={loading && <LoadingSymbol />}>
                    {loading ? TEXT_LOADING : TEXT_DEFAULT}</Button>

            </div>
        </>

    );
}

export default BtnAntragEinreichen;